import { useState } from 'react'

import { EuiButton, EuiToolTip } from '@equipmentshare/ds2'
import ConfirmCancelTransaction from '../ConfirmCancelTransaction'

import { TransactionType, Transaction } from '../../../../../../graphql'
import { CANCEL_RESTRICTED_TO_SENDER_TOOLTIP } from '../../../../../../constants/transfer-cancellation'
import useCanCancelTransaction from '../../../../effects/can-cancel-transaction'

import styles from '../ProcessingStatus/processing-status.module.css'

export type ProcessingStatusActionsProps = {
	onReceivePartsClick: () => void,
	transaction: Transaction,
}

export default function ProcessingStatusActions( { transaction, onReceivePartsClick }: ProcessingStatusActionsProps ) {
	const [ isConfirmCancelOpen, setIsConfirmCancelOpen ] = useState( false )
	const { canCancel, blockedAsReceiver } = useCanCancelTransaction( transaction )

	const hasReceiveButton = transaction.transactionType ? [ TransactionType.ProviderToStore, TransactionType.StoreToStore ].includes( transaction.transactionType ) : false

	return (
		<div className={styles.actionPopover}>
			{ isConfirmCancelOpen ? (
				<ConfirmCancelTransaction
					closeConfirm={() => setIsConfirmCancelOpen( false )}
					transaction={transaction}
				/>
			) : (
				<div>
					<h3>Actions</h3>
					<div className={styles.buttonWrapper}>
						<EuiToolTip content={blockedAsReceiver ? CANCEL_RESTRICTED_TO_SENDER_TOOLTIP : undefined}>
							<EuiButton
								color="danger"
								id="cancel-transaction-btn"
								isDisabled={!canCancel}
								onClick={() => setIsConfirmCancelOpen( true )}
							>
								Cancel transaction
							</EuiButton>
						</EuiToolTip>
						{ hasReceiveButton && (
							<EuiButton
								fill
								onClick={onReceivePartsClick}
							>
								Receive items
							</EuiButton>
						)}
					</div>
				</div>
			)}
		</div>
	)
}
